// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1_lw8","content":"LayoutSettings_content__1Y1-F"};